module.exports = "https://s91588.cdn.ngenix.net/reviews-frontend/_next/static/images/app_300_500_light-332d3fa7f929f5ab864fd47833477a33.png";